import {
  ODataHeader,
  ODataString,
  ODataInteger,
  ODataCustom,
  ODataEnum,
  ODataStringContains,
  ODataStringEndsWith,
  ODataStringEquals,
  ODataStringNotContains,
  ODataStringNotEquals,
  ODataStringStartsWith,
  ODataDateTime,
  ODataDecimal
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 3,
});

export default function getHeaders(enums) {
  return [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      searchable: false,
    }),
    // new ODataHeader({
    //   title: "headers.member_transactions.Transaction Type",
    //   type: new ODataEnum("Type", {
    //     getString: (item) => {
    //       return i18n.t("enums." + item.Type);
    //     },
    //     dropdownItems: enums.Type,
    //   }),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    // }),
    new ODataHeader({
      type: new ODataString("EligibilityHourBankId"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "headers.eligibility_bank.calendar_year",
      type: new ODataInteger("CalendarYear"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      version: 1,
    }),
    new ODataHeader({
      title: "headers.eligibility_bank.calendar_month",
      type: new ODataInteger("CalendarMonth"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      version: 1,
    }),
    new ODataHeader({
      title: "globals.amount",
      type: new ODataDecimal("Amount", {
        getString: (item, type) => {
          const value = item.Amount;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return value.toFixed(2);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.eligibility_bank.excess",
      type: new ODataDecimal("Excess", {
        getString: (item, type) => {
          const value = item.Excess;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return value.toFixed(2);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.actions",
      type: new ODataEnum("Action", {
        getString: (item) => {
          return i18n.t("enums." + item.Action);
        },
        dropdownItems: enums.EligibilityHourBankAction,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.reason",
      type: new ODataEnum("Reason", {
        getString: (item) => {
          if (
            item.CreditHourReason !== null &&
            item.CreditHourReason !== undefined &&
            item.CreditHourReason !== ""
          ) {
            return (
              i18n.t("enums." + item.Reason) + `(${item.CreditHourReason})`
            );
          }
          return i18n.t("enums." + item.Reason);
        },
        dropdownItems: enums.EligibilityHourBankReason,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    // new ODataHeader({
    //   title: "globals.trigger",
    //   type: new ODataString("User", {
    //     getString: (item) => {
          // if (item.SelfPaymentId !== null && item.SelfPaymentId !== undefined) {
          //   return `${i18n.t("enums.SelfPayment")}`
          // }
          // if (item.Action === "Deduction" || item.Action === "RevertDeduction") {
          //   return  `${i18n.t("globals.system")}`
          // }
    //       return `${item.User}`
    //     },
    //   }),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    // }),
    new ODataHeader({
      title: "globals.trigger",
      type: new ODataCustom("Role", {
        getString: (item, type) => {
          if (item.SelfPaymentId !== null && item.SelfPaymentId !== undefined) {
            return `${i18n.t("enums.SelfPayment")}`
          }
          if (item.Action === "Deduction" || item.Action === "RevertDeduction" || item.Reason === "MembershipChange" || item.Reason === "Rebalance") {
            return  `${i18n.t("globals.system")}`
          }
          return `${item.Role} (${item.User})`;
        },
        getWildcardFilter: (search) => {
          return `(((contains(tolower(Role), '${search}'))) or ((contains(tolower(User), '${search}')))`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      subHeaders: [
        new ODataHeader({
          title: "globals.trigger",
          type: new ODataCustom("Role", {
            getWildcardFilter: (search) => {
              return `(((contains(tolower(Role), '${search}'))) or ((contains(tolower(User), '${search}')))`;
            },
            getFilter: (callback) => {
              const res = callback("User");
              if (res.indexOf("not contains") > -1) {
                const search = res.split(",")[1].slice(0, -2).substring(2);
                return `((not contains(tolower(Role), '${search}'))) and ((not contains(tolower(User), '${search}')))`;
              } else if (res.indexOf("contains") > -1) {
                const search = res.split(",")[1].slice(0, -2).substring(2);
                return `((contains(tolower(Role), '${search}'))) or ((contains(tolower(User), '${search}')))`;
              }
              return undefined;
            },
            operators: [
              new ODataStringContains(),
              new ODataStringNotContains(),
            ],
          }),
          sortable: false,
          visible: true,
          searchable: true,
          subHeaders: [
            new ODataHeader({
              type: new ODataString("User"),
              visible: false,
              allowVisibilityChange: false,
              searchable: false,
              sortable: true,
            }),
          ],
        }),
        new ODataHeader({
          type: new ODataString("User"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
          sortable: true,
        }),
      ],
    }),
    new ODataHeader({
      title: "globals.timestamp",
      type: new ODataDateTime("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new ODataHeader({
      title: "headers.eligibility_bank.credit_hours_reason",
      type: new ODataString("CreditHourReason"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      version: 1,
    }),
    new ODataHeader({
      type: new ODataString("SelfPaymentId"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
  ];
}
